
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Publications from './components/Publications';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a4d2e] via-[#4a7c59] to-[#8b6f47]">
      <Navbar />
      <Hero />
      <Services />
      <Portfolio />
      <About />
      <Publications />
      <Contact />
      <Footer />
    </div>
  );
}
